export const TR_CONTENT = {
  hero: {
    kicker: 'Para transportadoras e frotas próprias',
    title: 'Você sabe quanto custa cada km rodado da sua frota? Se não sabe, está perdendo dinheiro.',
    subtitle:
      'Controle abastecimento, manutenção e custo por veículo em um só sistema — sem planilha, sem estimativa, com o número exato de cada km rodado.',
    cta: 'Quero o custo real da minha frota',
    ctaMessage: 'Quero conhecer o sistema para transportadora do 77Gestão',
    urgency: 'Cada mês sem esse controle é mais um mês de custo de frota que ninguém está enxergando.',
  },

  statsStrip: [
    { number: 'Por veículo', label: 'custo real calculado automaticamente', icon: 'fa-solid fa-gas-pump' },
    { number: 'Zero', label: 'quebra na estrada por manutenção esquecida', icon: 'fa-solid fa-triangle-exclamation' },
    { number: '1 sistema', label: 'para frota, compras e financeiro', icon: 'fa-solid fa-truck' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações na sua transportadora?',
    intro:
      'Quem toca frota sabe: o prejuízo não aparece de uma vez, ele se esconde em detalhe que ninguém está acompanhando de perto.',
    items: [
      { icon: 'fa-solid fa-road', text: 'Você não sabe ao certo quanto cada veículo custa por km rodado — só sente o resultado no caixa no fim do mês.' },
      { icon: 'fa-solid fa-oil-can', text: 'Manutenção feita "quando dá", não quando devia — e o veículo quebra na estrada, no pior momento.' },
      { icon: 'fa-solid fa-gas-pump', text: 'Abastecimento anotado em papel ou planilha, sem cruzar litros, km rodado e valor gasto por veículo.' },
      { icon: 'fa-solid fa-cart-shopping', text: 'Compra de peça e combustível sem controle central — cada filial ou motorista resolve do seu jeito.' },
      { icon: 'fa-solid fa-file-invoice-dollar', text: 'Financeiro da transportadora desorganizado, sem saber exatamente onde o dinheiro da operação está indo.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Nota fiscal de frete emitida separada do resto do controle de frota e financeiro.' },
    ],
  },

  midCta: {
    text: 'E se você abrisse o sistema e visse, na hora, o custo por km de cada veículo da frota?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para transportadora do 77Gestão',
  },

  solution: {
    title: 'Frota sob controle, do abastecimento à nota fiscal.',
    intro:
      'O 77Gestão organiza o dia a dia da transportadora em um único sistema: veículos, compras, financeiro e faturamento conectados.',
    cards: [
      {
        icon: 'fa-solid fa-gauge-high',
        title: 'Custo por km calculado automaticamente',
        text: 'Cada abastecimento registrado por litros, km rodado e valor gera o custo real por km de cada veículo — sem planilha, sem estimativa.',
      },
      {
        icon: 'fa-solid fa-screwdriver-wrench',
        title: 'Manutenção por veículo, preventiva e corretiva',
        text: 'Cadastre a manutenção de cada veículo e acompanhe o histórico — menos quebra inesperada na estrada.',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'Compras de peças e combustível integradas',
        text: 'Importe XML de NF-e do fornecedor e alimente estoque e financeiro automaticamente, sem digitar nota manualmente.',
      },
      {
        icon: 'fa-solid fa-sack-dollar',
        title: 'Financeiro único da operação',
        text: 'Contas a pagar e a receber da transportadora organizadas em um só lugar, conectadas às compras de peça e combustível.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Emissão de nota fiscal integrada',
        text: 'Emita NF-e/NFC-e direto do sistema, sem sair do controle de frota para faturar.',
      },
      {
        icon: 'fa-solid fa-warehouse',
        title: 'Estoque de peças por manutenção',
        text: 'Saiba o que tem no estoque de peças antes de uma manutenção parar o veículo por falta de item.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a transportadora para de operar no escuro',
    intro:
      'Uma transportadora com frota própria controlava abastecimento em caderno e só descobria o custo real da operação no fechamento do mês — tarde demais para corrigir qualquer coisa.',
    stats: [
      { number: '100%', label: 'de abastecimentos e manutenções registrados por veículo' },
      { number: '3x', label: 'mais rápido para levantar custo por km' },
      { number: '1 lugar', label: 'para frota, compras e financeiro' },
    ],
    paragraphs: [
      'Depois da implantação, cada abastecimento e manutenção passou a ser lançado por veículo, com litros, km e valor — o custo por km deixou de ser estimativa e passou a ser número exato.',
      'A compra de peças e combustível passou a alimentar o financeiro automaticamente, e a nota fiscal de frete saiu do mesmo sistema que controla a frota.',
    ],
    highlight: 'Resultado: custo real por veículo, menos quebra inesperada e financeiro organizado.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como controlar minha frota no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão da frota',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Custo por km, manutenção e abastecimento de cada veículo disponíveis a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Compra de peça e combustível centralizada, sem depender do que cada motorista ou filial resolve por conta própria.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Histórico de manutenção por veículo ajuda a antecipar o próximo serviço antes da quebra na estrada.',
      },
    ],
  },

  differentials: {
    title: 'Por que transportadoras escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Frota, compras, financeiro e nota fiscal integrados — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema adaptável ao tamanho da frota, de um veículo a dezenas.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe começa a lançar abastecimento e manutenção com apoio.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O sistema rastreia o veículo em tempo real, tipo GPS?',
        answer:
          'Não. O 77Gestão não faz rastreamento veicular ou telemetria em tempo real. O controle é sobre abastecimento, manutenção e custo por km de cada veículo — o que já resolve a maior dor de quem não sabe quanto cada veículo custa de fato.',
      },
      {
        question: 'Como o custo por km é calculado?',
        answer:
          'A partir dos registros de abastecimento por veículo (litros, km rodado e valor pago). O sistema cruza esses dados automaticamente e mostra o custo real por km, sem planilha.',
      },
      {
        question: 'Minha transportadora tem poucos veículos. Vale a pena?',
        answer:
          'Vale. Mesmo com poucos veículos, sem controle o custo real fica escondido. O sistema se adapta ao tamanho da frota, de um veículo a uma frota grande.',
      },
      {
        question: 'Dá para emitir nota fiscal direto do sistema?',
        answer:
          'Sim. A emissão de NF-e/NFC-e é integrada ao mesmo sistema que controla a frota, as compras e o financeiro.',
      },
      {
        question: 'Preciso digitar cada nota de compra de peça e combustível na mão?',
        answer:
          'Não necessariamente. O sistema importa XML de NF-e do fornecedor, alimentando estoque e financeiro sem digitação manual.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de operar a frota no escuro. Saiba o custo real de cada veículo.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como controlar abastecimento, manutenção e custo por km da sua frota em um único sistema.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para transportadora do 77Gestão',
  },

  seo: {
    title: 'Sistema para Transportadora — Controle de Frota e Custo por Km | 77Gestão',
    description:
      'Software de gestão de frota para transportadora: abastecimento, manutenção e custo por km controlados por veículo, compras integradas e emissão de nota fiscal. Agende uma demonstração.',
  },
};
